import type { CtaType } from '@/lib/types';

import { useCtaOffscreen } from './useCtaOffscreen';

export interface UseStickyPurchaseBarOpts {
  cta: CtaType | undefined;
  /** Whether pricing has loaded (watch gates its on-page CTA on this). */
  hasPricing?: boolean;
  productCatalogMode: boolean;
}

/**
 * Encapsulates the sticky purchase bar wiring shared by all PDP views: the
 * off-screen observer (callback ref) plus the visibility gate that mirrors the
 * on-page CTA render condition. Keeps the (already large) view components free
 * of this branching logic and dedupes it across Watch/Strap/Eyewear.
 */
export const useStickyPurchaseBar = ({
  cta,
  hasPricing = true,
  productCatalogMode,
}: UseStickyPurchaseBarOpts) => {
  const [ctaRef, isCtaOffscreen] = useCtaOffscreen();

  const visible = Boolean(
    !productCatalogMode && cta && hasPricing && isCtaOffscreen,
  );

  return { ctaRef, visible } as const;
};
